import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { policyStatementNodes } from './PolicyStatementContent';
import { renderH5PolicyNodes } from '../h5-policy/renderH5PolicyNodes';
import '../h5-policy/H5PolicyStyle.css';

const PolicyStatementPage: React.FC = observer(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '法律声明及隐私权政策';
  }, []);

  return (
    <div className="h5-policy-page">
      <div className="h5-policy user-rule policy-wrap policy-statement rules">
        {renderH5PolicyNodes(policyStatementNodes)}
      </div>
    </div>
  );
});

export default PolicyStatementPage;
